import { API } from 'services/constants';
import axios from 'services/axios';
import { default as mockAxios } from 'utils/axios';
import moment from 'moment';

const createAction = name => ({
  BRANCH_CHIP_CHANGE: `${name}_BRANCH_CHIP_CHANGE`,
  YEAR_CHANGE: `${name}_YEAR_CHANGE`,
  RESET_YEAR: `${name}_RESET_YEAR`,
  GET_DASHBOARD_PENDING: `${name}_GET_DASHBOARD_PENDING`,
  GET_DASHBOARD_SUCCESS: `${name}_GET_DASHBOARD_SUCCESS`,
  GET_DASHBOARD_FALIED: `${name}_GET_DASHBOARD_FALIED`,
  GET_MOCK_DASHBOARD_PENDING: `${name}_GET_DASHBOARD_PENDING`,
  GET_MOCK_DASHBOARD_SUCCESS: `${name}_GET_DASHBOARD_SUCCESS`,
  GET_MOCK_DASHBOARD_FALIED: `${name}_GET_DASHBOARD_FALIED`
});

export const DASHBOARD = createAction('DASHBOARD');

export const DashboardBranchChipChange = branchChips => dispatch => {
  dispatch({
    type: DASHBOARD.BRANCH_CHIP_CHANGE,
    payload: branchChips
  });
};

export const DashboardYearChange = date => dispatch => {
  dispatch({
    type: DASHBOARD.YEAR_CHANGE,
    payload: date
  });
};

export const DashboardResetYear = () => dispatch => {
  dispatch({ type: DASHBOARD.RESET_YEAR });
};

export const GetMockDashboard = () => async (dispatch, getState) => {
  dispatch({ type: DASHBOARD.GET_DASHBOARD_PENDING });
  try {
    const result = await mockAxios
      .get('/api/dashboard')
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    dispatch({
      type: DASHBOARD.GET_DASHBOARD_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: DASHBOARD.GET_DASHBOARD_FALIED,
      error
    });
  }
};

export const GetDashboard = () => async (dispatch, getState) => {
  dispatch({ type: DASHBOARD.GET_DASHBOARD_PENDING });
  try {
    const { authen, company, dashboard } = getState();
    const { loginUser } = authen;
    const { branchChips, startDate } = dashboard;

    const _companyId = company.select.id;
    let branchIdList = [];
    branchChips.forEach(branchChip => {
      branchIdList = [...branchIdList, branchChip.id];
    });

    const params = {
      companyId: loginUser.role === 'super' ? _companyId : loginUser.companyId,
      branchIds: branchIdList,
      year: parseInt(moment(startDate).format('YYYY')),
      qrType: ''
    };

    const result = await axios
      .post(API.POST_INQUIRY_DASHBOARD, params, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    dispatch({
      type: DASHBOARD.GET_DASHBOARD_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: DASHBOARD.GET_DASHBOARD_FALIED,
      error
    });
  }
};
